module.exports = __webpack_public_path__ + "assets/media/day7.15a58c7b.mp3";